module.exports = __webpack_public_path__ + "img/ISO_certification.29be4deb.png";